import { useState } from 'react';
import type { Filters } from './MakeModelKeywordSearch.typed';

/**
 * @param args filter values to be included in search payload
 * @returns Autocomplete options and input state and setter
 */
export const useMakeModelKeywordSearch = (_args: Filters) => {
  // TODO: Manage state of autocomplete input, format values for callback function if necessary: https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/111792/silent

  const [keyword] = useState('');

  const onChangeInput = () => {};

  // TODO: Add query: https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/111840/silent
  const isPending = false;

  const data = [
    {
      label: 'Volkswagen (all models)',
      value: { make: 'Volkswagen' },
      count: '5000',
    },
    {
      label: 'Volkswagen Golf',
      value: { make: 'Volkswagen', model: 'Golf' },
      count: '3000',
    },
    {
      label: 'Volkswagen Golf',
      value: { make: 'Volkswagen', model: 'Polo' },
      count: '2000',
    },
  ];

  const isError = false;

  return {
    keyword,
    onChangeInput,
    isPending,
    data,
    isError,
  };
};
